// Shared human-readable number/currency formatters.
// Tile/rollup values are stored in CENTS; helpers below take cents.

const USD0 = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
const USD2 = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
const NUM = new Intl.NumberFormat('en-US');

// "$824,497" — grouped, no cents. The default for headline tiles.
export function formatUsdCents(cents) {
  return USD0.format((cents || 0) / 100);
}

// "$824,497.46" — full precision, for small/exact figures.
export function formatUsdCentsExact(cents) {
  return USD2.format((cents || 0) / 100);
}

// "$1.2M" / "$824K" — compact, for tight spaces.
export function formatUsdCentsCompact(cents) {
  const v = (cents || 0) / 100;
  if (v >= 1_000_000) return `$${(v / 1_000_000).toFixed(1)}M`;
  if (v >= 10_000) return `$${Math.round(v / 1000)}K`;
  if (v >= 1000) return `$${(v / 1000).toFixed(1)}K`;
  return USD0.format(v);
}

// "40,506,656" — comma-grouped integer.
export function formatNumber(n) {
  return NUM.format(n || 0);
}
